/** @jsxImportSource @emotion/react */
import React from "react";
import { SerializedStyles, css } from "@emotion/react";
import { colors } from "./colors";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  additionalStyling?: SerializedStyles;
}

export const Divider = ({ additionalStyling, ...rest }: Props) => {
  const dividerStyle = css`
    display: flex;
    width: 100%;
    min-width: 100%;
    height: 1px;
    min-height: 1px;
    background-color: ${colors.greyBorder};
    ${additionalStyling}
  `;
  return <div css={dividerStyle} {...rest} />;
};
